import React, { useState, useEffect } from 'react';
import CondolenceList from './CondolenceList';
import './Condolences.css';

const CONDOLENCES_JSON = process.env.PUBLIC_URL + '/condolences.json';

function Condolences() {
  const [condolences, setCondolences] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    let cancelled = false;

    async function loadCondolences() {
      try {
        setLoading(true);
        setError(null);
        const response = await fetch(CONDOLENCES_JSON);
        if (!response.ok) throw new Error('Failed to load condolences');
        const data = await response.json();
        if (!cancelled) {
          setCondolences(Array.isArray(data) ? data : (data.condolences || []));
        }
      } catch (err) {
        if (!cancelled) {
          console.error('Error loading condolences:', err);
          setError(err.message);
          setCondolences([]);
        }
      } finally {
        if (!cancelled) setLoading(false);
      }
    }

    loadCondolences();
    return () => { cancelled = true; };
  }, []);

  return (
    <div className="condolences-page">
      <div className="container">
        <header className="page-header">
          <h1>Memories & Condolences</h1>
          <p className="page-subtitle">
            Messages shared in honor of Dr. Ernest Hew. To share your own kind words or memories, please email{' '}
            <a href="mailto:hewsat17@gmail.com">hewsat17@gmail.com</a>.
          </p>
        </header>

        <div className="condolences-content">
          <div className="list-column list-column-full">
            <h2 className="list-title">Messages of Love</h2>

            {loading ? (
              <div className="loading-state">
                <div className="loading-spinner"></div>
                <p>Loading messages...</p>
              </div>
            ) : error ? (
              <div className="empty-state">
                <p>Unable to load messages. Please try again later.</p>
              </div>
            ) : condolences.length === 0 ? (
              <div className="empty-state">
                <p>No messages yet.</p>
              </div>
            ) : (
              <CondolenceList condolences={condolences} />
            )}
          </div>
        </div>
      </div>
    </div>
  );
}

export default Condolences;
